import {Component, Input} from '@angular/core';
import {NgbDatepickerNavigation} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation';
import {MonthViewModel} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import {NgbCalendar, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'custom-datepicker-navigation',
  templateUrl: './custom-datepicker-navigation.component.html',
  styleUrls: ['./custom-datepicker-navigation.component.scss']
})
export class CustomDatepickerNavigationComponent extends NgbDatepickerNavigation {
  @Input()
  date: NgbDate;
  @Input()
  disabled: boolean;
  @Input()
  maxDate: NgbDate;
  @Input()
  minDate: NgbDate;
  @Input()
  months: MonthViewModel[];
  @Input()
  showSelect: boolean;
  @Input()
  showWeekNumbers: boolean;
  constructor(i18n: NgbDatepickerI18n, _calendar: NgbCalendar) {
    super(i18n, _calendar);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/custom-datepicker-navigation.component.ts